import { Users } from 'lucide-react';
import { Value } from 'sass';

export const AuthConstant = {
  ALL: 2000,
  SUPER_ADMIN: 2001,
  ADMIN: 2002,
  USER: 2003
};

export const DELETE_ALLOWED_ROLES = [AuthConstant.SUPER_ADMIN];

// Roles allowed to add/edit records
export const EDIT_ALLOWED_ROLES = [AuthConstant.SUPER_ADMIN, AuthConstant.ADMIN];

// Roles allowed to view records in readonly mode
export const READONLY_ROLES = [AuthConstant.ADMIN, AuthConstant.USER];

export const RoleConstant = {
  [AuthConstant.ALL]: 'All',
  [AuthConstant.SUPER_ADMIN]: 'Super Admin',
  [AuthConstant.ADMIN]: 'Admin',
  [AuthConstant.USER]: 'User'
};

export const MastersId = {
  USERS: 1,
  CITY: 2,
  ORGANIZATION_TYPE: 3,
  SPECALITY: 4,
  DESIGNATION: 5,
  MODULES: 6,
  CALL_TYPE: 7,
  DEMO_STATUS: 8,
  USER_NON_USER: 9,
  PRIORITY: 10,
  ISSUE_STATUS: 11,
  SOFTWARE_NAME: 12,
  AREA: 13,
  CLIENTS: 14,
  INSTALLATION_DETAILS: 15,
  AMC_LIST: 16,
  DCR_LIST: 17,
  DCR_CLIENTS: 18,
  DCR_CITY: 19,
  DCR_AREA: 20,
  ISSUE_PRODUCT: 21,
  ISSUES: 22,
  USER_ROLE: 2,
  ISSUE_TYPE: 12
};

export const MasterMenuTitleName = {
  [MastersId.USERS]: 'Users',
  [MastersId.CITY]: 'City',
  [MastersId.AREA]: 'Area',
  [MastersId.ORGANIZATION_TYPE]: 'Organization Type',
  [MastersId.SPECALITY]: 'Specality',
  [MastersId.DESIGNATION]: 'Designation',
  [MastersId.MODULES]: 'Modules',
  [MastersId.CALL_TYPE]: 'Call Type',
  [MastersId.DEMO_STATUS]: 'Demo Status',
  [MastersId.USER_NON_USER]: 'User/Non User',
  [MastersId.SOFTWARE_NAME]: 'Software Name'
};

export const ParentMenuTitle = {
  Dashboard: 'Dashboard',
  Masters: 'Masters',
  Clients: 'Clients',
  Installation_Details: 'Installation Details',
  AMC_List: 'AMC List',
  DCR: 'DCR',
  Issues: 'Issue Tracker'
};

export const MastersList = {
  [MastersId.USERS]: {
    id: MastersId.USERS,
    title: 'User Managment',
    message: 'Manage your users and their roles',
    icon: <Users className="w-5 h-5" />
    // content: <UsersList />,
  },
  [MastersId.ORGANIZATION_TYPE]: {
    id: MastersId.ORGANIZATION_TYPE,
    title: 'Organization Type',
    message: 'Manage your organization types',
    icon: <Users className="w-5 h-5" />
    // content: <UsersList />,
  },
  [MastersId.SPECALITY]: {
    id: MastersId.SPECALITY,
    title: 'Specality',
    message: 'Manage your specalities',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.DESIGNATION]: {
    id: MastersId.DESIGNATION,
    title: 'Designation',
    message: 'Manage your designations',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.MODULES]: {
    id: MastersId.MODULES,
    title: 'Modules',
    message: 'Manage your modules',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.CALL_TYPE]: {
    id: MastersId.CALL_TYPE,
    title: 'Call Type',
    message: 'Manage your call types',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.DEMO_STATUS]: {
    id: MastersId.DEMO_STATUS,
    title: 'Demo Status',
    message: 'Manage your demo statuses',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.USER_NON_USER]: {
    id: MastersId.USER_NON_USER,
    title: 'User / Non User',
    message: 'Manage your user and non user configuration',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.SOFTWARE_NAME]: {
    id: MastersId.SOFTWARE_NAME,
    title: 'Software Company Name',
    message: 'Manage your software company names',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.CLIENTS]: {
    id: MastersId.CLIENTS,
    title: 'Clients',
    message: 'Manage your clients',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.INSTALLATION_DETAILS]: {
    id: MastersId.INSTALLATION_DETAILS,
    title: 'Installation Details',
    message: 'Manage your installation details',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.AMC_LIST]: {
    id: MastersId.AMC_LIST,
    title: 'AMC List',
    message: 'Manage your AMC details',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.DCR_LIST]: {
    id: MastersId.DCR_LIST,
    title: 'DCR List',
    message: 'Manage your DCR details',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.DCR_CLIENTS]: {
    id: MastersId.DCR_CLIENTS,
    title: 'DCR Clients',
    message: 'Manage your DCR clients',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.DCR_CITY]: {
    id: MastersId.DCR_CITY,
    title: 'DCR City',
    message: 'Manage your DCR cities',
    icon: <Users className="w-5 h-5" />
  },
  [MastersId.DCR_AREA]: {
    id: MastersId.DCR_AREA,
    title: 'DCR Area',
    message: 'Manage your DCR areas',
    icon: <Users className="w-5 h-5" />
  }
};

export const ClientStatusOptions = [
  { value: 1, label: 'Active' },
  { value: 2, label: 'Inactive' }
];

/* ── Role options ─────────────────────────────────────────────────────────── */
export const RoleOptions = [
  {
    value: AuthConstant.SUPER_ADMIN,
    label: RoleConstant[AuthConstant.SUPER_ADMIN]
  },
  {
    value: AuthConstant.ADMIN,
    label: RoleConstant[AuthConstant.ADMIN]
  },
  {
    value: AuthConstant.USER,
    label: RoleConstant[AuthConstant.USER]
  }
];

export const paramsPrefix = '';

export const localStorageKeyName = 'userDetails';

export const ADMINCANEDIT = false;

export const amcTypeOptions = [
  { value: 'all', label: 'All' },
  { value: 'annual', label: 'Annual AMC' },
  { value: 'temp', label: 'Temp AMC' }
];

export const statusOption = [
  { value: 2, label: 'All' },
  { value: 1, label: 'Active' },
  { value: 0, label: 'In Active' }
];

export const FILE_ACCEPT_EXTENTION = '.pdf,.doc,.docx,.xls,.xlsx,.txt,.jpeg,.jpg,.png,.gif,.csv';